module.exports = __webpack_public_path__ + "img/terroir-spiral-1-mobile.819301fd.jpg";